import { render, staticRenderFns } from "./OwnerChange.vue?vue&type=template&id=6f039a5c&scoped=true&"
import script from "./OwnerChange.vue?vue&type=script&lang=js&"
export * from "./OwnerChange.vue?vue&type=script&lang=js&"
import style0 from "./OwnerChange.vue?vue&type=style&index=0&id=6f039a5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f039a5c",
  null
  
)

export default component.exports